import axios from "axios";
import { headersProvider } from "../pages/utilities";
export const getSignedAgreementList = async ({ page, filters }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/agreements/SignedagreementList`,
      { page, filters },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const createObligationApi = async ({ body }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/createobligation`,
      { ...body },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const updateObligationApi = async ({ body }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/updateobligation`,
      { ...body },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};
export const bulkUpdateObligationApi = async ({ data }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/bulkupdateobligation`,
      { data },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getObligationsForAgreement = async ({ local, agreementId }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getobligations`,
      { local, agreementId },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getauditHistory = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/audithistory/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getOverdueObligations = async ({ days } = {}) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/overdue`, {
      params: { days },
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error fetching overdue obligations!", error);
      throw error;
    });
};

export const getCompletedObligation = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/completed`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getAcceptObligations = async ({
  department,
  businessUnit,
  page,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getacceptobligations`,
      { department, businessUnit, page },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};
export const acceptObligation = async ({ id, recFrequency }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/acceptobligation`,
      { id, recFrequency },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getAssignedObligations = async ({
  department,
  page,
  businessUnit,
  pageSize,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getassignedobligation`,
      { department, page, businessUnit, pageSize },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getActionedObligations = async ({
  department,
  page,
  businessUnit,
  pageSize,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getactionedobligation`,
      { department, page, businessUnit, pageSize },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getObligationDetails = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getobligationDetails/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getObligationFiles = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/attachedfilestobligation/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const createLocalAgreement = async ({ agreementData }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/createagreement`,
      { agreementData },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getLocalAgreements = async ({ page, filters }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/docslocker`,
      { page, filters },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};
export const getLocalAgreementsCSV = async ({ page, filters }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/docslockercsv`,
      { page, filters },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};
export const getLocalAgreementDetails = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/localagreement/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getAllObligations = async ({
  page,
  filters,
  partyName,
  status,
  pageSize,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getallobligations`,
      { page, filters, partyName, status, pageSize },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting obligation", error);
      throw error;
    });
};

export const verifyEvidence = async ({ obligationId, fileId }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/verifyevidence`,
      { obligationId, fileId },
      { headers: headersProvider() }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error starting evidence verification", error);
      throw error;
    });
};

export const getVerifyEvidenceStatus = async ({ taskId, fileId, obligationId }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/verifyevidence/status/${taskId}`, {
      params: { fileId, obligationId },
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error fetching evidence verification status", error);
      throw error;
    });
};

export const getVerifyEvidenceResult = async ({ fileId }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/verifyevidence/result/${fileId}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error fetching the evidence verification result", error);
      throw error;
    });
};

export const assignObligationApi = async ({ id, assignToId }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/assignobligation`,
      { id, assignToId },
      { headers: headersProvider() }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error assigning the obligation", error);
      throw error;
    });
};
